import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { ReactNode } from "react";
import { PageFooter } from "./page-footer.component";
import { PageHeader } from "./page-header.component";

interface IPageLayoutProps {
  children: ReactNode;
}

export const PageLayout = ({ children }: IPageLayoutProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <PageHeader />
    <Container component="main" maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }}>
      {children}
    </Container>
    <PageFooter />
  </Box>
);
